import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider } from '@material-ui/core';
import { LanguageContext } from '../contexts/LanguageContext/languageContext';

interface AlertDialogProps {
  open: boolean;
  title: string;
  children?: React.ReactNode;
  confirmButtonTitle?: string;
  alertIcon?: any;
  closeIcon?: any;
  rootStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  maintitleStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  onConfirm: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  primaryColor?: string;
  divider?: boolean;
  className?: string;
}

export default function TGAlertDialog({
  open,
  title,
  children,
  confirmButtonTitle,
  onConfirm,
  onCancel,
  titleStyle,
  maintitleStyle,
  alertIcon,
  buttonStyle,
  rootStyle,
  onClose,
  closeIcon,
  contentStyle,
  primaryColor,
  divider,
  className,
}: AlertDialogProps) {
  const { translate } = useContext(LanguageContext);
  return (
    <div>
      <Dialog open={open} className={className}>
        <div style={rootStyle}>
          <DialogTitle id="alert-dialog-title" style={maintitleStyle || undefined}>
            {translate(title)}
          </DialogTitle>
          {closeIcon && (
            <div style={titleStyle || undefined}>
              <FontAwesomeIcon icon={closeIcon} onClick={onClose} />
            </div>
          )}
        </div>
        {divider && <Divider />}
        <DialogContent style={contentStyle}>
          <DialogContentText id="alert-dialog-description" component="div">
            {alertIcon ? (
              <div style={{ display: 'flex' }}>
                <FontAwesomeIcon
                  icon={alertIcon}
                  style={{ height: 45, color: primaryColor || '#56CCF2', marginRight: 15 }}
                />
                <div>{children}</div>
              </div>
            ) : (
              <div>{children}</div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {onCancel && (
            <Button onClick={onCancel} color="primary" style={buttonStyle}>
              {translate('Cancel')}
            </Button>
          )}
          <Button
            onClick={onConfirm}
            color="primary"
            autoFocus
            focusRipple={false}
            style={buttonStyle ? { ...buttonStyle, color: '#FFF', background: primaryColor || '#56CCF2' } : undefined}
          >
            <> {translate(confirmButtonTitle ?? 'Confirm')}</>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
